export const initFetch = {
  loading: false,
  error: null,
};
